import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { AuthContext } from '~contexts/auth';

import './style.scss';

const Email = () => {
  const intl = useIntl();

  const { user } = useContext(AuthContext);
  const { email } = user;
 
  return (
    <div className="c-box">
      <div className="c-box__content">
        <div className="c-editable">
          <div className="c-editable__content">
            <h3 className="l-headline--tertiary c-box__headline">
              {intl.formatMessage({ id: 'containers.account.email.headline', defaultMessage: 'E-mail address' })}
            </h3>
          </div>
        </div>

        {!email ? (
          <>
            <div className="c-editable">
              <div className="c-editable__content">
                <div className="c-account__value">
                  {intl.formatMessage({
                    id: 'containers.account.email.no-emails',
                    defaultMessage: 'You have not added any email addresses yet.',
                  })}
                </div>
              </div>
            </div>
          </>
        ) : null}

        {email ? (
          <div className="c-editable">
            <div className="c-editable__content">
              <div className="c-account__value">{email}</div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Email;
